export default {
	name: 'focus',
	directive: (el: HTMLElement) => {
		el.focus();
	}
};
